/* Sidecart only. Remember the choice across cart redraws, not page reloads. */
(() => {
  if (customElements.get('pp-cart-terms')) return;
  let accepted = false;
  customElements.define('pp-cart-terms', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="checkbox"]');
      if (!this.input) return;
      this.input.checked = accepted;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.input.addEventListener('change', () => {
        accepted = this.input.checked;
        this.input.setCustomValidity('');
      }, { signal });
      this.input.addEventListener('invalid', () => {
        this.input.setCustomValidity(this.input.checked ? '' : 'Acceptér handelsbetingelserne for at gå til kassen.');
      }, { signal });
      // Keep empty-cart resets in sync with Shopify's existing cart events.
      document.addEventListener('cart:updated', event => {
        if (event.detail?.cart?.item_count === 0) {
          accepted = false;
          this.input.checked = false;
        }
      }, { signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
  document.addEventListener('cart:updated', event => {
    if (event.detail?.cart?.item_count === 0) accepted = false;
  });
})();
